module.exports = __webpack_public_path__ + "static/media/w-logo.5d7388bc.png";